module.exports = __webpack_public_path__ + "static/media/country_dg.c65a3eb1.webp";